
//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

// import created components  :
import Background from '../../components/background/Background.jsx'
import ProgressBar from '../../components/progressbar/ProgressBar.jsx'
import BottomNav from '../../components/bottomnav/BottomNav.jsx'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getSelectedCreneaux, getFormules, getEleves, getFormulesEleves, getCommentaire, getClient, getResa } from "../../store/selectors.js";
import { resaSlice } from "../../store/resaSlice.js";

// API fetch
import axios from "axios";
import { baseURL } from '../../config/api-config.js';

//Utils 
import setNumResa from '../../utils/set_num_resa.js';



//MUI :
import Button from '@mui/material/Button';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import CheckIcon from '@mui/icons-material/Check';
import Alert from '@mui/material/Alert';

//Translate utils :
import { translator } from "../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function ResaValidate({ clientId }) { // full page as component imported in router

    let selectedCreneaux = useSelector(getSelectedCreneaux);
    let formulesEleves = useSelector(getFormulesEleves);
    let theClient = useSelector(getClient);
    let elevesList = useSelector(getEleves);
    let formulesList = useSelector(getFormules);
    let comment = useSelector(getCommentaire);
    const lang = useSelector(getLang) //global state : language

    let problemes = []; //list to store problems in requests
    let totalResa = 0; //amount of the current resa
    let currentClient = 0; //id of current client
    let currentResa = 0; // id of current resa (got from response)
    let idChanges = []; // list to store the switch of new eleve ids (from -1 to 345 for eg)

    const navigate = useNavigate();
    const dispatch = useDispatch();

    let alertBaseMessage = "Oups, une erreur est parvenue pendant l'enregistrement de votre demande. \n Vous pouvez réessayer à nouveau.\n Code erreur :";
    let [alertMessage, setAlertMessage] = useState("");
    let [showAlert, setShowAlert] = useState(false);
    //calculer le tarif total de la résa
    formulesEleves.map((formule) => { totalResa += formule.tarif_formule; });

    //// -- A faire : appliquer les reducs auto


    //// -- A faire : si nouveau client -> insérer et récupérer son ID
    // mettre à jour (put) le client courant

    function insertClient(idClient) {

        if (idClient > 0) { //dejà client ->update

            axios.put(`${baseURL}/client/${idClient}`, { //...we update
                prenom: theClient.prenom,
                nom: theClient.nom,
                email: theClient.email,
                tel: theClient.tel,
                tel2: theClient.tel2,
                adresse_vacances: theClient.adresse_vacances,
                is_eleve: false,
                eleve_id: 0
            })
                .then((response) => {
                    if (response.status === 200) { //modif ok : code 200...
                        // appeler fonction insert Resa
                        insertResa(idClient);
                    }
                    else {
                        problemes.push(response.data);
                        // ----- error management
                        setAlertMessage(alertBaseMessage + "Client-put" + response.status);
                        setShowAlert(true);
                        return;
                        // ---------------
                    }
                })
                .catch(error => {
                    problemes.push(error);
                    // ----- error management
                    setAlertMessage(alertBaseMessage + "Client-put" + error.message);
                    setShowAlert(true);
                    return;
                    // ---------------
                })

        }
        else { //new Client -> insert

            axios.post(`${baseURL}/client`, { //fetch create resa
                prenom: theClient.prenom,
                nom: theClient.nom,
                email: theClient.email,
                tel: theClient.tel,
                tel2: theClient.tel2,
                adresse_vacances: theClient.adresse_vacances,
                is_eleve: false,
                eleve_id: 0
            })
                .then((response) => {
                    if (response.status === 201) { // everything went good..
                        // appeler fonction insert Resa
                        insertResa(response.data.data.id_client);
                    }
                    else { // if probleme...
                        problemes.push(response.data); //add probleme to list
                        // ----- error management
                        setAlertMessage(alertBaseMessage + "Client-post" + response.status);
                        setShowAlert(true);
                        return;
                        // ---------------
                    }
                })
                .catch(error => {
                    //console.error(error);
                    problemes.push(error); //add probleme to list
                    // ----- error management
                    setAlertMessage(alertBaseMessage + "Client-post" + error.message);
                    setShowAlert(true);
                    return;
                    // ---------------
                })

        }
    }



    // créer la nouvelle résa et récupérezr l'id

    function insertResa(idClient) {

        currentClient = idClient;
        //console.log(formulesEleves)

        axios.post(`${baseURL}/resa`, { //fetch create resa
            client_id: idClient,
            nb_modifs: 0,
            match: false,
            coupon: 0,
            mode_reglement: 0,
            total: totalResa,
            solde: totalResa
        })
            .then((response) => {
                if (response.status === 201) { // everything went good..
                    // appeler fonction insert Resa/creneau
                    insertResaCreneaux(response.data.data.id_resa);
                    dispatch(resaSlice.actions.setResa({ ...response.data.data, numResa: setNumResa(response.data.data) }));
                }
                else { // if probleme...
                    problemes.push(response.data); //add probleme to list
                    // ----- error management
                    setAlertMessage(alertBaseMessage + "resa-post" + response.status);
                    setShowAlert(true);
                    return;
                    // ---------------
                }
            })
            .catch(error => {
                //console.error(error);
                problemes.push(error); //add probleme to list
                // ----- error management
                setAlertMessage(alertBaseMessage + "resa-post" + error.message);
                setShowAlert(true);
                return;
                // ---------------
            })

    }



    // faire une boucle pour remplir la table de jointure Resa/creneau

    function insertResaCreneaux(idResa) {
        //console.log(idResa)
        currentResa = idResa; // get resa id from previous fetch response
        let nbSuccess = 0; // to count the number of succesfull fetch

        selectedCreneaux.map((creneau) => { // we map all the selected creneaux

            axios.post(`${baseURL}/resa-creneau`, { //we fill the ResaCreneau db table...
                creneau_id: creneau.creneau.id_creneau,  //...with creneau id
                resa_id: idResa                            //...and resa id
            })
                .then((response) => {
                    if (response.status === 201) { // if request ok
                        nbSuccess++;  // ...we increment compteur
                        if (nbSuccess === selectedCreneaux.length) { // if nbsuccess = number of selected creneaux...

                            insertEleves(); //... we go to next step, insert eleves
                        }

                    }
                    else { //
                        problemes.push(response.data);
                        // ----- error management
                        setAlertMessage(alertBaseMessage + "ResaCreneau-post" + response.status);
                        setShowAlert(true);
                        return;
                        // ---------------
                    }
                })
                .catch(error => {

                    problemes.push(error);
                    // ----- error management
                    setAlertMessage(alertBaseMessage + "ResaCreneau-post" + error.message);
                    setShowAlert(true);
                    return;
                    // ---------------
                })
        });// end of map

    }

    //// -- function to remove eleves unchecked and with no creneau attended 
    function listElevesCleaner(rootList, mode) {
        let dirtList = [];

        if (mode === 1) { //mode 1 : to clean listEleves from redux global state
            dirtList = rootList.filter((eleve) => (eleve.checked === true)); //to remove eleves attending session, but thereafter unchecked
        }
        else { //mode 2 ; to clean Creneau.eleves

            dirtList = rootList.filter((eleve) => elevesList.find((e) => e.id === eleve.id).checked === true);
        }

        let cleanList = [];
        dirtList.map((eleve) => {
            let nbCours = formulesEleves.find((formule) => formule.id_eleve === eleve.id).nb_cours;
            if (nbCours > 0) { cleanList.push(eleve); }
        });

        //console.log("cleanList", cleanList);
        return cleanList;
    }


    function insertEleves() {
        let nbSuccess = 0; // init compteur for request success
        let elevesCleanList = listElevesCleaner(elevesList, 1); // we "clean" the list of allEleves

        elevesCleanList.map((eleve) => { // we map every eleve in the list
            //// -- A faire = gérer les nouveaux eleves dans la liste mais avec 0 créneaux

            if (eleve.id < 0) { //eleve not already in database...
                axios.post(`${baseURL}/eleve`, { //...we add him in the db
                    prenom: eleve.prenom,
                    age: eleve.age,
                    niveau_id: eleve.niveau,
                    fidelite_id: eleve.fidelite,
                    client_id: currentClient,
                    nb_cours: 0
                })
                    .then((response) => {
                        if (response.status === 201) { //insertion ok...
                            //we add a correspondance old id (negative) / new id (from DB):
                            idChanges.push({ old: eleve.id, new: response.data.data.id_eleve })
                            nbSuccess++;
                            //console.log(nbSuccess, elevesCleanList.length);
                            if (nbSuccess === elevesCleanList.length) { //every request went good
                                insertCreneauxEleves(); // All good , go to la suite
                            }

                        }
                        else {
                            problemes.push(response.data);
                            // ----- error management
                            setAlertMessage(alertBaseMessage + "eleves-post" + response.status + " " + eleve.id);
                            setShowAlert(true);
                            return;
                            // ---------------
                        }
                    })
                    .catch(error => {
                        problemes.push(error);
                        // ----- error management
                        setAlertMessage(alertBaseMessage + "eleve-post" + error.message);
                        setShowAlert(true);
                        return;
                        // ---------------
                    })

            }
            else { // eleve already recorded, just update

                axios.put(`${baseURL}/eleve/${eleve.id}`, { //...we add him in the db
                    prenom: eleve.prenom,
                    age: eleve.age,
                    niveau_id: eleve.niveau,
                    fidelite_id: eleve.fidelite,
                    client_id: currentClient,
                    nb_cours: 0
                })
                    .then((response) => {
                        if (response.status === 200) { //modif ok : code 200...
                            nbSuccess++;
                            if (nbSuccess === elevesCleanList.length) { //every request went good
                                insertCreneauxEleves(); // All good , go to la suite
                            }

                        }
                        else {
                            problemes.push(response.data);
                            // ----- error management
                            setAlertMessage(alertBaseMessage + "eleve-put" + response.status + " " + eleve.id);
                            setShowAlert(true);
                            return;
                            // ---------------
                        }
                    })
                    .catch(error => {
                        problemes.push(error);
                        // ----- error management
                        setAlertMessage(alertBaseMessage + "eleve-put" + error.message);
                        setShowAlert(true);
                        return;
                        // ---------------
                    })
            }

        })
    }

    // bulk create :
    function insertCreneauxEleves() {

        problemes.length = 0; // reset array to empty

        let batch = [];

        selectedCreneaux.map((creneau) => { // first we map every selected creneaux ...
            //console.log(creneau.eleves);
            let cleanElevesList = listElevesCleaner(creneau.eleves, 2); // clean to remove ids of eleves finally not checked 

            cleanElevesList.map((eleve) => { // ... and map every eleves for each creneau

                // get the correct id if eleve is new (id<0) or not : 
                let idEleve = eleve.id > 0 ? eleve.id : newIdFinder(eleve.id); //newIdFinder returns the id received from response if new eleve 

                batch.push({ // insert new line in CReneauEleve table ...
                    creneau_id: creneau.creneau.id_creneau, //... with creneau id
                    eleve_id: idEleve, //...eleve id
                    resa_id: currentResa // and IMPORTANT resa id
                });
            }); // end of map eleves

        });// end of map selected creenaux

        // bulk create
        axios.post(`${baseURL}/creneau-eleve/bulk`, batch)
            .then((response) => {
                if (response.status === 201) { // insertion ok
                    console.log("tout bon nouveau algo ");
                    console.log(batch);
                    console.log(response.data.data);
                    insertCommentaire();
                }
                else { // probleme insertion
                    problemes.push("probleme");
                    // ----- error management
                    setAlertMessage(alertBaseMessage + "CreneauEleve-post" + response.status);
                    setShowAlert(true);
                    return;
                    // ---------------
                }
            })
            .catch(error => {
                problemes.push("probleme");
                // ----- error management
                setAlertMessage(alertBaseMessage + "CreneauEleve-post" + error.message);
                setShowAlert(true);
                return;
                // ---------------
            })


    } // end of  insertCreneauxEleves()


    // create 1 by 1
    /* function insertCreneauxEleves() {

        problemes.length = 0; // reset array to empty
        let cpt = 0;
        let nbSucces1 = 0;
        let nbSucces2 = 0;
        let nbSuccessAll = 0;

        selectedCreneaux.map((creneau) => { // first we map every selected creneaux ...


            //console.log(creneau.eleves);
            let cleanElevesList = listElevesCleaner(creneau.eleves, 2); // clean to remove ids of eleves finally not checked 

            cleanElevesList.map((eleve) => { // ... and map every eleves for each creneau
                cpt++; //to count the number of loops
                console.log(cleanElevesList.length);

                // get the correct id if eleve is new (id<0) or not : 
                let idEleve = eleve.id > 0 ? eleve.id : newIdFinder(eleve.id); //newIdFinder returns the id received from response if new eleve 
                console.log(eleve.id);

                axios.post(`${baseURL}/creneau-eleve`, { // insert new line in CReneauEleve table ...
                    creneau_id: creneau.creneau.id_creneau, //... with creneau id
                    eleve_id: idEleve, //...eleve id
                    resa_id: currentResa // and IMPORTANT resa id
                })
                    .then((response) => {
                        if (response.status === 201) { // insertion ok
                            nbSucces2++;
                            console.log(idEleve, response.status, nbSucces1, nbSucces2, cleanElevesList.length);
                            if (nbSucces2 === cleanElevesList.length) {
                                nbSucces1++;
                                nbSucces2 = 0;
                                if (nbSucces1 === selectedCreneaux.length) {
                                    console.log("tout bon nouveau algo " + nbSucces1 + " " + nbSucces2);
                                    nbSucces1 = 0;
                                    nbSucces2 = 0;
                                    console.log("tout bon");
                                    insertCommentaire();
                                }
                            }
                            


                        }
                        else { // probleme insertion
                            problemes.push("probleme");
                            // ----- error management
                            setAlertMessage(alertBaseMessage + "CreneauEleve-post" + response.status);
                            setShowAlert(true);
                            return;
                            // ---------------
                        }
                    })
                    .catch(error => {
                        problemes.push("probleme");
                        // ----- error management
                        setAlertMessage(alertBaseMessage + "CreneauEleve-post" + error.message);
                        setShowAlert(true);
                        return;
                        // ---------------
                    })
            }); // end of map eleves

        });// end of map selected creenaux

        



    } */

    function insertCommentaire() {

        if (comment.length > 0) { // commentaire présent

            axios.post(`${baseURL}/resa-commentaire`, { //fetch create resa
                commentaire: comment,
                by_client: true,
                resa_id: currentResa // and IMPORTANT resa id
            })
                .then((response) => {
                    if (response.status === 201) { // everything went good..
                        // confirmer l'ensemble des requetes
                        confirmSave(true);
                    }
                    else { // if probleme...
                        problemes.push(response.data); //add probleme to list
                        // ----- error management
                        setAlertMessage(alertBaseMessage + "Comment-post" + response.status);
                        setShowAlert(true);
                        return;
                        // ---------------
                    }
                })
                .catch(error => {
                    //console.error(error);
                    problemes.push(error); //add probleme to list
                    // ----- error management
                    setAlertMessage(alertBaseMessage + "Comment-post" + error.message);
                    setShowAlert(true);
                    return;
                    // ---------------
                })

        }
        else {
            confirmSave(true);
        }


    }


    function newIdFinder(oldId) {
        return (idChanges.find((ligne) => ligne.old === oldId).new); // returns the new id from db for new eleve with negative id
    }

    function confirmSave(success) { // handle insertions completion => show message for exemple
        if (success === true) {
            console.log("c'est bon on t'a dit");

            navigate("../resasuccess")
        }
    }


    return (
        <div>

            <Button
                className="bottom-nav-next-confirm"
                disabled={selectedCreneaux.length === 0}
                onClick={_ => insertClient(clientId)}
                variant="contained">
                {translator("Envoyez votre demande de réservation", lang, "confirmResaEnvoyer")} <CheckIcon />
            </Button>
            {showAlert === true &&
                <Alert className="bottom-nav-next-confirm-alert" severity="error">{alertMessage}</Alert>
            }
        </div>
    );
}

export default ResaValidate;